var staticStrUndefined = 'undefined'

module.exports = staticStrUndefined



//////////////////
// WEBPACK FOOTER
// ./~/.store/xe-utils@3.5.27/~/xe-utils/staticStrUndefined.js
// module id = 60
// module chunks = 75